<template>
  <b-card>
    <!------ TABLE ------>

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template slot="bottom-row" scope="data">
        <td align="right" :span="data.columns" colspan="4">
          <b>Grand Total (RM)</b>
        </td>
        <td :span="data.columns">{{ grandp.toFixed(2) }}</td>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    grandp: {
      type: String
    }
  },
  methods: {}
};
</script>
<style lang="css" scoped></style>
